import script from "./object_Teaser.vue?vue&type=script&setup=true&lang=js"
export * from "./object_Teaser.vue?vue&type=script&setup=true&lang=js"

import "./object_Teaser.vue?vue&type=style&index=0&id=b06640ee&lang=scss&scoped=true"

import exportComponent from "/home/dmytro/Projects/gcs/frontend/homepage/gc-schoenbuch/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-b06640ee"]])

export default __exports__